import { render, staticRenderFns } from "./Enfoques.vue?vue&type=template&id=b5790eca"
import script from "./Enfoques.vue?vue&type=script&lang=js"
export * from "./Enfoques.vue?vue&type=script&lang=js"
import style0 from "./Enfoques.vue?vue&type=style&index=0&id=b5790eca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports